/**
 * APP 环境重定向（关闭并打开新的页面）
 */
import { Level, reportCustomMetric, reportError } from "../owl";
import { isHttpScheme } from "../utils";
import { BridgeType, callKNBBridge, callMSIBridge, getBridgeType } from "./base";

/* ----- MSI.jumpToLink 类型声明 start ----- */
// https://msi-extend.sankuai.com/api?tab=C&id=1424
interface MSIJumpToLinkProps {
  url: string;
  success?: (res: MSIJumpToLinkSuccessCbParams) => void;
  fail?: (err: MSIJumpToLinkFailCbParams) => void;
  complete?: () => void;
  openWebByHttpUrl?: boolean;
}

interface MSIJumpToLinkSuccessCbParams {
  errMsg: string; // 响应信息
  errno: number; // 响应码
}

interface MSIJumpToLinkFailCbParams {
  errMsg: string; // 响应信息
  errno: number; // 响应码
}
/* ----- MSI.jumpToLink 类型声明 end ----- */

/* ----- KNB.jumpPage 类型声明 start ----- */
// https://km.sankuai.com/collabpage/418094558
interface KNBJumpPageProps {
  url: string;
  // url 为 HTTP 协议时，内部会拼接 imeituan://www.meituan.com/web，并将 query 作为协议链接的参数
  // 容器跳转Scheme参数：https://km.sankuai.com/collabpage/19154204
  query?: {
    openInApp?: 1 | 2; // 1 - 美团APP打开，2 - 三方APP打开
    notitlebar?: 0 | 1; // 0 - 有默认标题栏，1 - 隐藏标题栏
    future?: 1 | 2 | 4; // notitilebar = 1 生效，1 - 动态标题栏，2 - 全屏沉浸式（仅安卓），4 - 隐藏虚拟按键（下巴）
  };
  success?: () => void;
  fail?: (err: any) => void;
}
/* ----- KNB.jumpPage 类型声明 end ----- */

interface OpenPageProps {
  url: string;
  onSuccess?: () => void;
  onFail?: (err: any) => void;
}

const bridgeType = getBridgeType();

type JumpPageErrMsg = 'success' | 'emptyUrl' | 'KNBBridgeFail' | 'MSIBridgeFail' | 'GrowthMSIBridgeNotSupport';
// 上报 jumpPage 成功率
function reportJumpPageSuccessRate(isSuccess: boolean, errMsg: JumpPageErrMsg = "success") {
  reportCustomMetric({
    key: "jumpPage",
    value: isSuccess ? 1 : 0,
    tags: {
      errMsg,
      bridgeType,
    },
  });
}
export default function jumpPage(props: OpenPageProps) {
  if (!props.url) {
    reportError({
      name: "[jumpPage] jumpPageError",
      msg: `props.url is empty: ${JSON.stringify(props)}`,
      category: "bridgeError",
      level: Level.ERROR,
    });
    reportJumpPageSuccessRate(false, "emptyUrl");
    return;
  }
  switch (bridgeType) {
    case BridgeType.KNB:
      callKNBBridge("jumpPage", {
        url: props.url,
        // query 仅当 URL 为 HTTP 协议才生效
        query: {
          openInApp: 1, // 在美团 APP 中打开
        },
        // 不要依赖 openPage success，如果当前success执行过长会导致下个webview卡住
        success: () => {
          if (typeof props.onSuccess === "function") {
            props.onSuccess();
          }
          reportJumpPageSuccessRate(true, "success");
        },
        fail: function (error) {
          if (typeof props.onFail === "function") {
            props.onFail(error);
          }
          reportError({
            name: "[jumpPage] KNBJumpPageError",
            msg:  error,
            category: "bridgeError",
            level: Level.WARN,
          });
          reportJumpPageSuccessRate(false, "KNBBridgeFail");
        },
      } as KNBJumpPageProps);
      break;
    case BridgeType.MSI:
      callMSIBridge("jumpToLink", {
        url: props.url,
        openWebByHttpUrl: isHttpScheme(props.url),
        success: () => {
          if (typeof props.onSuccess === "function") {
            props.onSuccess();
          }
          reportJumpPageSuccessRate(true, "success");
        },
        fail: (err) => {
          if (typeof props.onFail === "function") {
            props.onFail(err);
          }
          reportError({
            name: "[jumpPage] MSIJumpToLinkError",
            msg: err,
            category: "bridgeError",
            level: Level.WARN,
          });
          reportJumpPageSuccessRate(false, "MSIBridgeFail");
        },
      } as MSIJumpToLinkProps);
      break;
    case BridgeType.GROWTH_MSI:
      // 外投容器暂不支持重定向方法
      reportJumpPageSuccessRate(false, "GrowthMSIBridgeNotSupport");
      reportError({
        name: "[jumpPage] GrowthMSIBridgeNotSupportError",
        msg: `GrowthMSIBridgeNotSupport: ${JSON.stringify(props)}`,
        category: "bridgeError",
        level: Level.ERROR,
      });
      break;
    default:
      break;
  }
}
